export const BASKET = '/basket/lines';
export const BASKET_STATISTICS = '/basket/stats';
export const BASKET_TOP = '/catalog/top/basket';
